import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-white shadow-lg' : 'bg-white/10 backdrop-blur-md'
    }`}>
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/a46cb40b-1cc8-4b1d-b1b5-871bb0fb0d23.png" 
              alt="CAISA S.R.L. Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className={`text-xl font-bold transition-colors ${
              isScrolled ? 'text-gray-900' : 'text-white'
            }`}>CAISA S.R.L.</span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button 
              onClick={() => scrollToSection('home')}
              className={`font-medium transition-all hover:text-teal-500 relative group ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Home
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-500 transition-all group-hover:w-full"></span>
            </button>
            <button 
              onClick={() => scrollToSection('vpn-service')}
              className={`font-medium transition-all hover:text-teal-500 relative group ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              VPN Service
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-500 transition-all group-hover:w-full"></span>
            </button>
            <button 
              onClick={() => scrollToSection('features')}
              className={`font-medium transition-all hover:text-teal-500 relative group ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Features
              <span className="absolute bottom-0 left-0 w-0.5 bg-teal-500 transition-all group-hover:w-full"></span>
            </button>
            <button 
              onClick={() => scrollToSection('about')}
              className={`font-medium transition-all hover:text-teal-500 relative group ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About Us
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-500 transition-all group-hover:w-full"></span>
            </button>
            <button 
              onClick={() => scrollToSection('contact')}
              className={`font-medium transition-all hover:text-teal-500 relative group ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-teal-500 transition-all group-hover:w-full"></span>
            </button>
          </div>

          <button 
            onClick={() => scrollToSection('contact')}
            className="hidden md:block px-6 py-2.5 bg-teal-500 text-white font-semibold rounded-full hover:bg-teal-600 hover:shadow-lg hover:shadow-teal-500/50 transition-all whitespace-nowrap"
          >
            Get Started
          </button>
        </div>
      </div>
    </nav>
  );
}